import React from 'react';
import { ArrowLeftIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/components/capstone/base';
import { AlertsCopyAllButton } from '../AlertsCopyAllButton';
import { StyledBackNavigation } from './DataCards.styles';
import ShareIncidentButton from './ShareIncident/ShareIncidentButton';
import { getAlertHeaderColor, getAlertHeaderText } from './utils';

const BPLaptopDataCardHeader = React.forwardRef(
  (
    {
      onClose,
      emergencyType,
      siteType,
      alertStatus,
      serviceProviderName,
      setIsShareIncidentModalOpen,
      isShareIncidentAvailable,
      subtype,
      headerActions,
    },
    ref,
  ) => {
    const headerColor = getAlertHeaderColor(emergencyType, alertStatus);
    return (
      <Box mb={2} data-name="alert-data-card-header" ref={ref}>
        <Box justify="space-between" horizontal>
          <Box horizontal flow={20}>
            <StyledBackNavigation onClick={() => onClose()}>
              <ArrowLeftIcon height={16} width={16} />
              <Text ml="3px" size="normal">
                Go Back
              </Text>
            </StyledBackNavigation>
            <Box>
              <Text color={headerColor} fontWeight="bold" size="normal">
                {getAlertHeaderText(emergencyType, siteType)}
              </Text>
              {subtype && (
                <Text color="secondaryText" size="small">
                  {subtype}
                </Text>
              )}
              <Text color="secondaryText" size="small">
                Source: {serviceProviderName}
              </Text>
            </Box>
          </Box>
          <Box horizontal align="center">
            {headerActions}
            {isShareIncidentAvailable && (
              <ShareIncidentButton
                setIsShareIncidentModalOpen={setIsShareIncidentModalOpen}
              />
            )}
            <AlertsCopyAllButton />
          </Box>
        </Box>
      </Box>
    );
  },
);

export default BPLaptopDataCardHeader;
